import { fork } from "redux-saga/effects";

import { sagas as ReportFormSagas } from "./modules/ReportForm";
import { sagas as ReportSagas } from "./modules/Report";
import { sagas as MerchantSagas } from "./modules/Merchant";
import { sagas as UserSagas } from "./modules/User";
import { sagas as AdminSagas } from "./modules/Admin";
import { sagas as AnalyticsSagas } from "./modules/Analytics";
import { sagas as AnalyticsMetricSagas } from "./modules/AnalyticsMetric";
import { sagas as StoreVisitsSagas } from "./modules/StoreVisits";

// Should this definition be somewhere else?
export default function* root() {
  yield [
    fork(ReportFormSagas.watchGetSchema),
    fork(ReportFormSagas.watchGetReport),
    fork(ReportFormSagas.watchSubmitForm),
    fork(ReportFormSagas.watchEditForm),
    fork(ReportFormSagas.watchCreateReport),
    fork(ReportSagas.watchGetReports),
    fork(ReportSagas.watchGetReportFiles),
    fork(ReportSagas.watchDeleteReport),
    fork(ReportSagas.watchSelectMerchant),
    fork(ReportSagas.watchResendReportFile),
    fork(ReportSagas.watchSendLatestReport),
    fork(MerchantSagas.watchGetMerchants),
    fork(MerchantSagas.watchGetMerchant),
    fork(UserSagas.watchLogin),
    fork(UserSagas.watchLogout),
    fork(AdminSagas.watchGetFailedReports),
    fork(AdminSagas.watchRegenerateReport),
    fork(AdminSagas.watchResendReports),
    fork(AdminSagas.watchRegenerateSystemFailures),
    fork(AnalyticsSagas.watchGetAggregatedMetrics),
    fork(AnalyticsSagas.watchGetAnalyticsMerchants),
    fork(AnalyticsSagas.watchSetMetricSelection),
    fork(AnalyticsSagas.watchSetGlobalFilterSelection),
    fork(AnalyticsMetricSagas.watchGetFlyers),
    fork(AnalyticsMetricSagas.watchGetFlyerItems),
    fork(AnalyticsMetricSagas.watchGetToplineMetrics),
    fork(AnalyticsMetricSagas.watchGetSfmlData),
    fork(AnalyticsSagas.watchGetPublications),
    fork(AnalyticsMetricSagas.watchGetMetricData),
    fork(StoreVisitsSagas.watchSynchronizeQueryString),
    fork(StoreVisitsSagas.watchGetStoreVisitsMerchants),
    fork(StoreVisitsSagas.watchGetStoreVisitsPublications),
    fork(StoreVisitsSagas.watchGetTopStoresData)
  ];
}



// WEBPACK FOOTER //
// ./client/saga.js